import { observer } from "mobx-react-lite";
import { useStore } from "../helpers";
import { TailwindModal } from "../components";
import ThumbnailImage from "./Thumbnail";
import React from "react";

type FullScreenImagePropTypes = {
  s3Key: string;
  bucket?: string;
  width: number;
  height: number;
};

const FullScreenImage = observer((props: FullScreenImagePropTypes) => {
  const { userStore } = useStore();
  const { bucket = "urn-assets", width, height, s3Key } = props;

  return (
    <TailwindModal isOpen={userStore.thumbnail_modal}>
      <div className="relative flex h-[90vh] w-full items-center justify-center overflow-hidden rounded-lg bg-white shadow-xl">
        <ThumbnailImage width={width} height={height} bucket={bucket} s3Key={s3Key} fit="FIT" />
        <button
          type="button"
          aria-label="Close preview"
          className="absolute right-3 top-3 z-10 flex h-9 w-9 items-center justify-center rounded-full bg-white text-red-600 shadow-md hover:bg-gray-100"
          onClick={() => userStore.update_thumbnail_modal(false)}
        >
          <i className="fa-solid fa-xmark text-xl" />
        </button>
      </div>
    </TailwindModal>
  );
});

export default FullScreenImage;